// ************ FORM INITIALIZE MATRIX- START ************ //
import {MatrixInitializationValues} from "../../../api/types/ancillaryDetail";
import * as yup from "yup";
import {maxNumberYupLimit, minNumberYupLimit} from "../../../constants";

export const initialValues: MatrixInitializationValues = {
    matrixInitializationType: 0,
    carGroups: [],
    rentalPeriods: [],
    sell: null,
    price: null,
    ancillary: null,
    discountIncreasePercentage: null,
    discountIncreaseFixed: null
};

export const validationSchema = ({t}: { t: Function }) => yup.object().shape({
    carGroups: yup
        .array().of(yup.string())
        .nullable()
        .when("matrixInitializationType", {
            is: 0,
            then: yup
                .array().of(yup.string())
                .nullable()
                .min(1, t("translation:validation.atLeastOneRequired"))
        }),
    rentalPeriods: yup
        .array().of(yup.object().shape({
            code: yup.string(),
            label: yup.string()
        }))
        .nullable()
        .when("matrixInitializationType", {
            is: 0,
            then: yup
                .array().of(yup.object().shape({
                    code: yup.string(),
                    label: yup.string()
                }))
                .nullable()
                .min(1, t("translation:validation.atLeastOneRequired"))
        }),
    sell: yup.object().shape({
        code: yup.string(),
        label: yup.string()
    }).nullable()
        .required(t("translation:validation.fieldMandatory")),
    ancillary: yup
        .object().shape({
            code: yup.string(),
            label: yup.string()
        })
        .nullable()
        .when("matrixInitializationType", {
            is: 1,
            then: yup
                .object().shape({
                    code: yup.string(),
                    label: yup.string()
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory"))
        }),
    discountIncreasePercentage: yup
        .number()
        .integer()
        .nullable()
        .typeError(t("pricing:alert.errors.integer"))
        .min(-99, t("pricing:validation.numberGreaterThan") + -99)
        .max(100, t("pricing:validation.numberLowerThan") + 100),
    discountIncreaseFixed: yup
        .number()
        .transform((o, v) => v ? parseFloat(v.replace(/,/g, ".")) : v)
        .nullable()
        .min(minNumberYupLimit, t("pricing:validation.numberGreaterThan") + minNumberYupLimit)
        .max(maxNumberYupLimit, t("pricing:validation.numberLowerThan") + maxNumberYupLimit),
});
// ************ FORM INITIALIZE MATRIX - END ************ //